import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../mock';

const KONTAKTOPTIONEN = [
  {
    typ: 'Telefon',
    icon: Phone,
    beschreibung: 'Für eine schnelle Abstimmung.',
    buttonText: 'Jetzt anrufen',
    link: `tel:${COMPANY_INFO.phone}`,
    isPrimary: true
  },
  {
    typ: 'WhatsApp',
    icon: MessageCircle,
    beschreibung: 'Wenn Sie lieber kurz schreiben möchten.',
    buttonText: 'WhatsApp schreiben',
    link: `https://wa.me/${COMPANY_INFO.whatsapp}`,
    isPrimary: false
  }
];

export const KontaktOptionen = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Kontaktkanäle
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            So erreichen Sie uns
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {KONTAKTOPTIONEN.map((option, index) => {
            const Icon = option.icon;
            return (
              <div key={index} className="bg-white border border-gray-200 rounded-3xl p-12 shadow-lg hover:shadow-2xl transition-all duration-300 text-center">
                <div className="w-20 h-20 bg-brand-green/10 rounded-2xl flex items-center justify-center mx-auto mb-8 border border-brand-green/15">
                  <Icon className="w-10 h-10 text-brand-green" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{option.typ}</h3>
                <p className="text-gray-600 leading-relaxed mb-8 text-lg">{option.beschreibung}</p>
                
                <a href={option.link} target={option.isPrimary ? undefined : "_blank"} rel={option.isPrimary ? undefined : "noopener noreferrer"}>
                  <Button size="lg" className={`w-full ${option.isPrimary ? 'bg-brand-green hover:bg-brand-green-dark text-white' : 'bg-gray-900 hover:bg-gray-800 text-white'} text-lg px-10 py-6 rounded-2xl font-semibold`}>
                    <Icon className="w-5 h-5 mr-3" />
                    {option.buttonText}
                  </Button>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};